"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _splice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/splice"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _flags = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/flags"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/createClass"));
var _vue = _interopRequireDefault(require("vue"));
var _lodash = _interopRequireDefault(require("lodash"));
var _common = require("./common");
var _batchedAdd = _interopRequireDefault(require("../batchedAdd"));
var bufferTools = _interopRequireWildcard(require("../bufferTools"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/** @module */

var nextBufferId = 0;

/** The IRC buffer instance */
var BufferState = exports.default = /*#__PURE__*/function () {
  function BufferState(name, networkid, state, messageDict) {
    (0, _classCallCheck2.default)(this, BufferState);
    // Enumerable properties that become reactive under Vue
    this.id = nextBufferId++;
    this.networkid = networkid;
    this.name = name;
    this.topics = [];
    this.topic_by = '';
    this.topic_when = 0;
    this.key = '';
    this.joined = false;
    this.enabled = true;
    this.created_at = null;
    this.users = Object.create(null);
    this.modes = Object.create(null);
    this.flags = {
      unread: 0,
      highlight: false,
      has_opened: false,
      channel_badkey: false,
      chathistory_available: true,
      requested_modes: false,
      requested_banlist: false,
      requested_invitelist: false,
      is_visible: false,
      is_requesting_chathistory: false
    };
    this.settings = {};
    this.last_read = 0;
    this.active_tab = null;
    this.active_timeout = null;
    this.message_count = 0;
    this.current_input = '';
    this.input_history = [];
    this.input_history_pos = 0;
    this.show_input = true;
    this.latest_messages = [];

    // Counter for chathistory requests. While this value is 0, it means that this buffer is
    // still loading messages
    this.chathistory_request_count = 0;
    _vue.default.observable(this);

    // Some non-enumerable properties (vues $watch won't cover these properties)
    (0, _common.def)(this, 'state', state, false);
    (0, _common.def)(this, 'messageDict', messageDict, false);
    var messagesObj = {
      networkid: this.networkid,
      buffer: this.name,
      messages: [],
      messageIds: Object.create(null)
    };
    this.messageDict.push(messagesObj);
    (0, _common.def)(this, 'messagesObj', messagesObj, false);
    (0, _common.def)(this, 'isMessageTrimming', true, true);
    (0, _common.def)(this, 'addMessageBatch', createMessageBatch(this), false);
    (0, _common.def)(this, 'addUserBatch', createUserBatch(this), false);

    // poll who to update away status if away-notify is not enabled
    if (this.isChannel()) {
      maybeStartWhoLoop(this);
    }

    // When the network re-connects, we reset the chathistory request counter.
    // This will make the `getLoadingState()` stay as 'loading' while the chathistory reloads.
    function onNetworkConnecting(event) {
      if (event.network === this.getNetwork()) {
        this.chathistory_request_count = 0;
      }
    }
    function onNetworkMotd(event, network) {
      var _context;
      var bufferNetwork = this.getNetwork();
      if (network !== bufferNetwork || !bufferNetwork.ircClient.chathistory.isSupported() || !this.isQuery()) {
        return;
      }
      if ((0, _includes.default)(_context = ['all', 'queries']).call(_context, this.setting('auto_request_history'))) {
        this.requestLatestScrollback();
      }
    }

    // Clean up the previous event and itself when the buffer is closed.
    function onBufferClose(event) {
      if (event.buffer === this) {
        this.state.$off('network.connecting', onNetworkConnectingBound);
        this.state.$off('buffer.close', onBufferCloseBound);
        this.state.$off('irc.motd', onNetworkMotdBound);
      }
    }
    var onNetworkConnectingBound = onNetworkConnecting.bind(this);
    var onBufferCloseBound = onBufferClose.bind(this);
    var onNetworkMotdBound = onNetworkMotd.bind(this);
    state.$on('network.connecting', onNetworkConnectingBound);
    state.$on('buffer.close', onBufferCloseBound);
    state.$on('irc.motd', onNetworkMotdBound);
  }
  (0, _createClass2.default)(BufferState, [{
    key: "topic",
    get: function get() {
      var _this$topics$;
      return (_this$topics$ = this.topics[0]) !== null && _this$topics$ !== void 0 ? _this$topics$ : '';
    },
    set: function set(newVal) {
      var maxLength = 5;
      this.topics.unshift(newVal);
      if (this.topics.length > maxLength) {
        this.topics.length = maxLength;
      }
    }
  }, {
    key: "isVisible",
    get: function get() {
      return this.flag('is_visible');
    },
    set: function set(_newVal) {
      var newVal = _newVal;
      if (this.active_tab && this.active_tab !== 'messages') {
        // Prevent newVal from being true if we are on a tabbed buffer
        // and the active tab is not 'messages'
        newVal = false;
      }
      this.flag('is_visible', newVal);
      if (newVal) {
        this.flag('unread', 0);
        this.flag('highlight', false);
        this.markAsRead(true);
        return;
      }

      // Buffer is no longer visible
      if (this.active_timeout) {
        this.markAsRead(false);
      }
    }
  }, {
    key: "getNetwork",
    value: function getNetwork() {
      return this.state.getNetwork(this.networkid);
    }
  }, {
    key: "getMessages",
    value: function getMessages() {
      var bufMessages = (0, _find.default)(_lodash.default).call(_lodash.default, this.messageDict, {
        networkid: this.networkid,
        buffer: this.name
      });
      return bufMessages ? bufMessages.messages : [];
    }
  }, {
    key: "getLastMessage",
    value: function getLastMessage() {
      var messages = this.getMessages();
      if (messages.length === 0) {
        return undefined;
      }
      return messages[messages.length - 1];
    }
  }, {
    key: "clearMessages",
    value: function clearMessages() {
      var _context2;
      (0, _splice.default)(_context2 = this.messagesObj.messages).call(_context2, 0, this.messagesObj.messages.length);
      this.messagesObj.messageIds = Object.create(null);
    }

    // Remove a block of messages between a time (server-time) range. Inclusive.
  }, {
    key: "clearMessageRange",
    value: function clearMessageRange(startTime, endTime) {
      var _context3,
        _this = this;
      this.messagesObj.messages = (0, _filter.default)(_context3 = this.messagesObj.messages).call(_context3, function (message) {
        if (message.server_time < startTime || message.server_time > endTime) {
          return true;
        }

        // This message will be removed
        delete _this.messagesObj.messageIds[message.id];
        return false;
      });

      // Mark that something changed
      this.message_count++;
    }
  }, {
    key: "isServer",
    value: function isServer() {
      return this.name === '*';
    }
  }, {
    key: "isRaw",
    value: function isRaw() {
      return this.name === '*raw';
    }
  }, {
    key: "isChannel",
    value: function isChannel() {
      var chanPrefixes = ['#', '&'];
      var ircNetwork = this.getNetwork().ircClient.network;
      if (ircNetwork && ircNetwork.options.CHANTYPES) {
        chanPrefixes = ircNetwork.options.CHANTYPES;
      }
      return chanPrefixes.indexOf(this.name[0]) > -1;
    }
  }, {
    key: "isQuery",
    value: function isQuery() {
      var chanPrefixes = ['#', '&'];
      var ircNetwork = this.getNetwork().ircClient.network;
      if (ircNetwork && ircNetwork.options.CHANTYPES) {
        chanPrefixes = ircNetwork.options.CHANTYPES;
      }
      return chanPrefixes.indexOf(this.name[0]) === -1 && !this.isSpecial() && !this.isServer();
    }
  }, {
    key: "isSpecial",
    value: function isSpecial() {
      // Special buffer names (Usually controller queries, like *status or *raw).
      // Server buffer '*' is not included in this classification.
      var name = this.name;
      return name[0] === '*' && name.length > 1;
    }
  }, {
    key: "isUserAnOp",
    value: function isUserAnOp(nick) {
      var user = this.state.getUser(this.networkid, nick);
      if (!user) {
        return false;
      }
      var userBufferInfo = user.buffers[this.id];
      if (!userBufferInfo) {
        return false;
      }
      var modes = userBufferInfo.modes;
      var opModes = ['Y', 'y', 'q', 'a', 'o', 'h'];
      var hasOp = (0, _find.default)(_lodash.default).call(_lodash.default, modes, function (mode) {
        return opModes.indexOf(mode.toLowerCase()) > -1;
      });
      return !!hasOp;
    }

    /**
     * Get a users prefix symbol on a buffer from its modes
     * @param {Object} user The user object
     */
  }, {
    key: "userModePrefix",
    value: function userModePrefix(user) {
      // The user may not be on the buffer
      if (!user.buffers[this.id]) {
        return '';
      }
      var modes = user.buffers[this.id].modes;
      if (modes.length === 0) {
        return '';
      }
      var network = this.getNetwork();
      var netPrefixes = network.ircClient.network.options.PREFIX;
      // Find the first (highest) netPrefix in the users buffer modes
      var prefix = (0, _find.default)(_lodash.default).call(_lodash.default, netPrefixes, function (p) {
        return modes.indexOf(p.mode) > -1;
      });
      return prefix ? prefix.symbol : '';
    }

    /**
     * Get a users mode on a buffer
     * @param user {Object} The user object
     */
  }, {
    key: "userMode",
    value: function userMode(user) {
      // The user may not be on the buffer
      if (!user.buffers[this.id]) {
        return '';
      }
      var modes = user.buffers[this.id].modes;
      if (modes.length === 0) {
        return '';
      }

      // if there is only one mode just return it
      if (modes.length === 1) {
        return modes[0];
      }
      var network = this.getNetwork();
      var netPrefixes = network.ircClient.network.options.PREFIX;
      // Find the first (highest) netPrefix in the users buffer modes
      var prefix = (0, _find.default)(_lodash.default).call(_lodash.default, netPrefixes, function (p) {
        return modes.indexOf(p.mode) > -1;
      });
      return prefix ? prefix.mode : '';
    }
  }, {
    key: "setting",
    value: function setting(name, val) {
      if (typeof val !== 'undefined') {
        this.state.$set(this.settings, name, val);
        return val;
      }

      // Check the buffer specific settings before reverting to global settings
      var result = typeof this.settings[name] !== 'undefined' ? this.settings[name] : this.state.setting('buffers.' + name);
      return result;
    }
  }, {
    key: "rename",
    value: function rename(newName) {
      var network = this.getNetwork();
      var oldName = this.name;
      var setActive = this.state.getActiveBuffer() === this;
      this.name = newName;
      if (setActive) {
        this.state.setActiveBuffer(network.id, newName);
      }

      // update the buffer name on our messages
      var bufferMessages = (0, _find.default)(_lodash.default).call(_lodash.default, this.messageDict, {
        networkid: network.id,
        buffer: oldName
      });
      bufferMessages.buffer = newName;
    }
  }, {
    key: "flag",
    value: function flag(name, val) {
      if (typeof val !== 'undefined') {
        this.state.$set((0, _flags.default)(this), name, val);
        return val;
      }
      return (0, _flags.default)(this)[name];
    }
  }, {
    key: "requestScrollback",
    value: function requestScrollback(_direction) {
      var direction = _direction || 'backward';
      var time = '';
      var chathistoryFuncName = 'before';

      // Going backwards takes the earliest message we already have and requests messages
      // before it. Going forward takes the last message we have and requests messages after
      // it.

      if (direction === 'backward') {
        var lastMessage = this.getMessages().reduce(function (earliest, current) {
          var ignoreTypes = ['traffic', 'topic', 'connection', 'presence'];
          var validType = ignoreTypes.indexOf(earliest.type) === -1;
          if (validType && earliest.time && earliest.time < current.time) {
            return earliest;
          }
          return current;
        }, this.getMessages()[0]);
        chathistoryFuncName = 'before';
        time = lastMessage ? new Date(lastMessage.server_time) : new Date();
      } else if (direction === 'forward') {
        var firstMessage = this.getMessages().reduce(function (latest, current) {
          var ignoreTypes = ['traffic', 'topic', 'connection', 'presence'];
          var validType = ignoreTypes.indexOf(latest.type) === -1;
          if (validType && latest.time && latest.time > current.time) {
            return latest;
          }
          return current;
        }, this.getMessages()[0]);
        chathistoryFuncName = 'after';
        time = firstMessage ? new Date(firstMessage.server_time) : new Date();
      } else {
        throw new Error('Invalid direction for requestScrollback(): ' + _direction);
      }
      getBufferHistory(this, chathistoryFuncName, time);
    }
  }, {
    key: "requestLatestScrollback",
    value: function requestLatestScrollback() {
      getBufferHistory(this, 'latest', '*');
    }
  }, {
    key: "markAsRead",
    value: function markAsRead(delayed) {
      if (this.active_timeout) {
        clearTimeout(this.active_timeout);
        this.active_timeout = null;
      }
      if (delayed) {
        this.active_timeout = setTimeout(this.markAsRead.bind(this), 10000, false);
      } else {
        this.last_read = Date.now();

        // If running under a bouncer, set it on the server-side too
        var network = this.getNetwork();
        var allowedUpdate = !network ? false : this.isChannel() || this.isQuery();
        if (allowedUpdate && network.connection.bncnetid) {
          network.ircClient.bnc.bufferSeen(network.connection.bncnetid, this.name);
        }
      }
    }
  }, {
    key: "incrementFlag",
    value: function incrementFlag(flagName) {
      (0, _flags.default)(this)[flagName] = ((0, _flags.default)(this)[flagName] || 0) + 1;
    }
  }, {
    key: "addUser",
    value: function addUser(user) {
      this.addUserBatch(user);
    }
  }, {
    key: "hasNick",
    value: function hasNick(nick) {
      var nickUpper = nick.toUpperCase();
      return nickUpper in this.users || this.addUserBatch.queue().some(function (u) {
        return u.nick.toUpperCase() === nickUpper;
      }) || this.isQuery() && this.name.toUpperCase() === nickUpper;
    }
  }, {
    key: "hasMode",
    value: function hasMode(mode) {
      return (0, _keys.default)(this.modes).indexOf(mode) > -1;
    }
  }, {
    key: "shouldShareTyping",
    value: function shouldShareTyping() {
      var network = this.getNetwork();
      if (!this.setting('share_typing')) {
        // Feature disabled
        return false;
      }
      if (!this.isChannel() && !this.isQuery()) {
        // Qnly share tying with channels and queries
        return false;
      }
      if (this.isChannel() && !this.joined) {
        // Channel is in an unjoined state
        return false;
      }
      if (this.hasMode('m') && !this.userMode(network.currentUser())) {
        // Channel is moderated (+m) and we do not have a user mode +v or above
        return false;
      }
      return true;
    }
  }, {
    key: "banUser",
    value: function banUser(user) {
      if (!user.username || !user.host) {
        return;
      }
      var banMask = user.createBanMask();
      this.getNetwork().ircClient.raw('MODE', this.name, '+b', banMask);
    }
  }, {
    key: "kickUser",
    value: function kickUser(user, _reason) {
      var reason = _reason || this.state.setting('buffers.default_kick_reason');
      this.getNetwork().ircClient.raw('KICK', this.name, user.nick, reason);
    }
  }, {
    key: "banKickUser",
    value: function banKickUser(user, reason) {
      this.banUser(user);
      this.kickUser(user, reason);
    }
  }, {
    key: "removeUser",
    value: function removeUser(nick) {
      var userObj = this.state.getUser(this.networkid, nick);

      // A user could be queued to be added, so make sure it's not there as it
      // would just be added again. Eg. user joins/parts during a flood
      _lodash.default.pull(this.addUserBatch.queue(), userObj);
      this.state.$delete(this.users, nick.toUpperCase());
      if (userObj) {
        delete userObj.buffers[this.id];
      }
    }
  }, {
    key: "clearUsers",
    value: function clearUsers() {
      var _context4,
        _this2 = this;
      // Users could be queued to be added, so make sure to clear them as they
      // would just be added again. Eg. user joins/parts during a flood
      this.addUserBatch && (0, _splice.default)(_context4 = this.addUserBatch.queue()).call(_context4, 0);
      _lodash.default.each(this.users, function (userObj, nick) {
        delete userObj.buffers[_this2.id];
      });
      this.state.$set(this, 'users', {});
    }
  }, {
    key: "addMessage",
    value: function addMessage(message) {
      this.addMessageBatch(message);
    }
  }, {
    key: "updateLatestMessages",
    value: function updateLatestMessages(message) {
      var _context5,
        _this3 = this;
      if (!(0, _includes.default)(_context5 = ['privmsg', 'notice']).call(_context5, message.type)) {
        return;
      }
      var isNewer = function isNewer(msg) {
        return _this3.latest_messages[0].time <= msg.time && _this3.latest_messages[0].instance_num < msg.instance_num;
      };
      if (!this.latest_messages[0] || isNewer(message)) {
        this.latest_messages.unshift(message);
      }
      if (this.latest_messages.length > 5) {
        // restrict array to 5 elements
        this.latest_messages.length = 5;
      }
    }
  }, {
    key: "getLatestMessage",
    value: function getLatestMessage() {
      return this.latest_messages[0];
    }
  }, {
    key: "say",
    value: function say(message) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var network = this.getNetwork();
      var newMessage = {
        time: Date.now(),
        nick: network.nick,
        message: message,
        tags: opts.tags || {},
        type: opts.type || 'privmsg'
      };
      this.state.addMessage(this, newMessage);
      var fnNames = {
        privmsg: 'say',
        action: 'action',
        notice: 'notice',
        tagmsg: 'tagmsg'
      };
      var fnName = fnNames[opts.type] || 'say';
      network.ircClient[fnName](this.name, message, opts.tags);
    }
  }, {
    key: "join",
    value: function join() {
      if (!this.isChannel()) {
        return;
      }
      var network = this.getNetwork();
      network.ircClient.join(this.name, this.key || '');
    }
  }, {
    key: "part",
    value: function part(reason) {
      if (!this.isChannel()) {
        return;
      }
      var network = this.getNetwork();
      network.ircClient.part(this.name, reason || '');
    }
  }, {
    key: "scrollToMessage",
    value: function scrollToMessage(id) {
      this.state.$emit('messagelist.scrollto', {
        id: id
      });
    }
  }, {
    key: "getLoadingState",
    value: function getLoadingState() {
      var networkState = this.getNetwork().state;
      var historySupport = !!this.getNetwork().ircClient.chathistory.isSupported();
      var messagesInBatchQueue = this.addMessageBatch.queue().length;
      // Hack; We need to make vue aware that we depend on message_count in order to
      // update the loading state.
      // eslint-disable-next-line no-unused-vars
      var messageCount = this.message_count;
      if (networkState === 'disconnected') {
        return 'disconnected';
      } else if (networkState === 'connecting') {
        return 'connecting';
      } else if (networkState === 'connected' && this.enabled && historySupport && ((0, _flags.default)(this).is_requesting_chathistory ||
      // If chathistory is supported then a request will always be made when first
      // joining a channel. If request_count===0 then we're still waiting for it
      // to happen.
      this.chathistory_request_count === 0 ||
      // keep in loading state while the batch is being processed
      messagesInBatchQueue > 0)) {
        return 'loading';
      }
      return 'done';
    }
  }, {
    key: "isReady",
    value: function isReady() {
      return this.getLoadingState() === 'done';
    }
  }]);
  return BufferState;
}();
/**
 * Batch up floods of addUsers for a huge performance gain.
 * Generally happens when reconnecting to a BNC
 */
function createUserBatch(bufferState) {
  var addSingleUser = function addSingleUser(u) {
    bufferState.state.$set(bufferState.users, u.nick.toUpperCase(), u);
  };
  var addMultipleUsers = function addMultipleUsers(users) {
    var o = (0, _assign.default)(Object.create(null), bufferState.users);
    users.forEach(function (u) {
      o[u.nick.toUpperCase()] = u;
    });
    bufferState.users = o;
  };
  return (0, _batchedAdd.default)(addSingleUser, addMultipleUsers, 2);
}

/**
 * batch up floods of new messages for a huge performance gain
 */
function createMessageBatch(bufferState) {
  var addSingleMessage = function addSingleMessage(newMessage) {
    if (bufferState.messagesObj.messageIds[newMessage.id]) {
      return;
    }
    bufferState.updateLatestMessages(newMessage);
    bufferState.messagesObj.messages.push(newMessage);
    bufferState.messagesObj.messageIds[newMessage.id] = newMessage;
    if (bufferState.isMessageTrimming) {
      trimMessages();
    }
    bufferTools.orderedMessages(bufferState, {
      inPlace: true,
      noFilter: true
    });
    bufferState.message_count++;
  };
  var addMultipleMessages = function addMultipleMessages(newMessages) {
    var toAdd = (0, _filter.default)(newMessages).call(newMessages, function (msg) {
      return !bufferState.messagesObj.messageIds[msg.id];
    });
    if (toAdd.length > 0) {
      var _context6;
      bufferState.messagesObj.messages = (0, _concat.default)(_context6 = bufferState.messagesObj.messages).call(_context6, toAdd);
      toAdd.forEach(function (msg) {
        bufferState.updateLatestMessages(msg);
        bufferState.messagesObj.messageIds[msg.id] = msg;
      });
      if (bufferState.isMessageTrimming) {
        trimMessages();
      }
      bufferTools.orderedMessages(bufferState, {
        inPlace: true,
        noFilter: true
      });
    }
    // Trigger Vue's reactivity on the buffer whether messages were added or not, just in case
    // anything was depending on the batch queue which has now been emptied.
    bufferState.message_count++;
  };
  var trimMessages = function trimMessages() {
    var scrollbackSize = bufferState.setting('scrollback_size');
    var length = bufferState.messagesObj.messages.length;
    if (length > scrollbackSize) {
      var _context7;
      var removed = (0, _splice.default)(_context7 = bufferState.messagesObj.messages).call(_context7, 0, length - scrollbackSize);
      removed.forEach(function (msg) {
        return delete bufferState.messagesObj.messageIds[msg.id];
      });
    }
  };
  return (0, _batchedAdd.default)(addSingleMessage, addMultipleMessages, 4);
}

// Update our user list status every 30seconds to get each users current away status
function maybeStartWhoLoop(bufferState) {
  var network = bufferState.state.getNetwork(bufferState.networkid);
  if (network.state === 'connected') {
    // network is connected start the loop if its needed
    nextLoop();
  } else {
    // Network is not coonnected. Wait until it is
    var on001 = function on001(command, event, eventNetwork) {
      if (eventNetwork === network) {
        bufferState.state.$off('irc.raw.001', on001);
        nextLoop();
      }
    };
    bufferState.state.$on('irc.raw.001', on001);
  }
  function nextLoop() {
    setTimeout(updateWhoStatusLoop, 30000);
  }
  function updateWhoStatusLoop() {
    network = bufferState.state.getNetwork(bufferState.networkid);

    // Make sure the network still exists
    if (!network) {
      return;
    }

    // Make sure the buffer still exists
    if (!network.bufferByName(bufferState.name)) {
      return;
    }
    var whoLoop = bufferState.setting('who_loop');
    var isJoined = bufferState.joined;
    var hasAwayNotify = network.ircClient.network.cap.isEnabled('away-notify');
    var networkConnected = network.state === 'connected';
    if (whoLoop && networkConnected && isJoined && !hasAwayNotify) {
      network.ircClient.who(bufferState.name, function () {
        nextLoop();
      });
    } else {
      nextLoop();
    }
  }
}
function getBufferHistory(buffer, chathistoryFuncName, time) {
  var ircClient = buffer.getNetwork().ircClient;
  buffer.flag('is_requesting_chathistory', true);
  buffer.chathistory_request_count += 1;
  var existingMessageIds = (0, _assign.default)({}, buffer.messagesObj.messageIds);
  ircClient.chathistory[chathistoryFuncName](buffer.name, time).then(function (event) {
    if (!event) {
      buffer.flag('chathistory_available', false);
      return;
    }

    // The BNC server may reply with messages that are already in the buffer.
    // If we get no new messages that we didn't already have, assume that we have
    // all the available history
    var hasNewMessages = event.commands.some(function (msg) {
      return msg.tags.msgid && !existingMessageIds[msg.tags.msgid];
    });

    // If there are new messages, then there could be more in the backlog.
    // If there are no new messages, then the chat history is empty.
    buffer.flag('chathistory_available', hasNewMessages);
  }).finally(function () {
    buffer.flag('is_requesting_chathistory', false);
  });
}